import { rand, randFloat, randCurrencyCode } from '@ngneat/falso';

import { COD, CODTypes } from '../base';

export class MockCOD extends COD {
   constructor() {
      super();

      this.type = rand([ ...CODTypes ]);
      this.amount = +randFloat();
      this.currency = randCurrencyCode();
   }
}
